/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
Buyapowa.Controllers.ReferrerPopover = class ReferrerPopover {
  constructor(el) {
    this._handleResponse = this._handleResponse.bind(this);
    this._handleFailure = this._handleFailure.bind(this);
    this.el = el;
    this.view = new Buyapowa.Views.ReferrerPopover(this.el, this);
    this.view.setStep(1);
    this._trackEvent("shown");
  }

  submitClicked() {
    this.view.setInProgress(this.view.statusTexts("in_progress"));
    return $.ajax({
      url: this.view.submitUrl(),
      data: this.view.formData(),
      type: "POST"
    }).done(this._handleResponse)
    .fail(this._handleFailure);
  }

  urlCopied() {
    return this._trackEvent("short_url_copied");
  }

  urlShared() {
    return this._trackEvent("short_url_shared");
  }

  linkClicked(step) {
    return this._trackEvent(`link_click_${step}`);
  }

  _handleResponse(data) {
    if (data.ok) {
      this.view.setFinished(true, this.view.statusTexts("success"));
      this.view.setShortUrl(data.short_url);
      this.view.setStep(2);
      return this._trackEvent("signup");
    } else {
      return this._handleFailure(null);
    }
  }

  _handleFailure() {
    return this.view.setFinished(false, this.view.statusTexts("failure"));
  }

  _trackEvent(eventName) {
    return this.view.getEventMethod(`referrer_popover_${eventName}`)();
  }
};
